(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gammelbrev-permission"] && !Shopify.designMode) return;
  try {
    (() => {
    const current = new URL(window.location.href);
    if (!current.searchParams.has('gammelbrev-erhverv-ja-tak')) return;
    const dialog = document.getElementById('GammelbrevPermission');
    if (!dialog) return;
    const link = dialog.querySelector('[data-permission-destination]');
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    const preview = current.searchParams.get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) destination.searchParams.set('preview_theme_id', preview);
    link.href = destination.href;
    current.searchParams.delete('gammelbrev-erhverv-ja-tak');
    window.history.replaceState(null, '', current.pathname + current.search + current.hash);
    if (typeof dialog.showModal !== 'function') { window.location.replace(destination.href); return; }
    dialog.showModal();
    const redirect = window.setTimeout(() => window.location.replace(destination.href), 6000);
    dialog.addEventListener('close', () => window.clearTimeout(redirect), { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
